"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts = require("../constants");
function warekiToDate(gengoAlpha, gengoYear, month, date, hour, minute, second) {
    if (month === void 0) { month = 1; }
    if (date === void 0) { date = 1; }
    if (hour === void 0) { hour = 0; }
    if (minute === void 0) { minute = 0; }
    if (second === void 0) { second = 0; }
    var gengo = consts.date.gengo.find(function (_a) {
        var alpha = _a.alpha;
        return alpha === gengoAlpha;
    });
    if (!gengo) {
        throw new Error("\"" + gengoAlpha + "\"\u306F\u5143\u53F7\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u306B\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002");
    }
    if (!gengoYear) {
        throw new Error('年は1以上を指定してください。');
    }
    var seirekiYear = gengo.start[0] + gengoYear - 1;
    return new Date(seirekiYear, month - 1, date, hour, minute, second);
}
exports.default = warekiToDate;
